import { UntypedFormGroup, ValidatorFn } from '@angular/forms'
import { Matrix } from 'app/models/questions/Matrix'
import { ViewerTypeEnum } from 'app/enums/ViewerTypeEnum'

export function requireMinStatementSelection(matrix: Matrix): ValidatorFn {
  return function validate(formGroup: UntypedFormGroup) {
    if (!matrix.limitAnswersAmount || matrix.viewerType === ViewerTypeEnum.CHECKBOX) {
      return null
    }

    let statementKeyCounts = {}

    const rowKeys = Object.keys(formGroup.controls)

    if (rowKeys.length) {
      matrix.statementKeys.forEach(sKey => {
        statementKeyCounts[sKey] = 0
      })
    }

    for (const idx in rowKeys) {
      const rowControl = formGroup.controls[rowKeys[idx]]

      if (!rowControl.enabled) {
        continue
      }

      const rawRowSelectedControlValues = formGroup.getRawValue()[rowKeys[idx]][matrix.formControlName]

      for (const sKey in rawRowSelectedControlValues) {
        if (rawRowSelectedControlValues[sKey]) {
          statementKeyCounts[sKey]++
        }
      }
    }

    for (const cIdx in statementKeyCounts) {
      if (statementKeyCounts[cIdx] < matrix.minAnswers.statements) {
        return {
          requireMinStatementSelection: true
        }
      }
    }

    return null
  }
}
